import { Suspense } from "react";
import { RouterProvider } from "react-router";
import { SWRConfig } from "swr";
import { ThemeProvider } from "@/components/theme-provider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { swrFetcher } from "@/lib/api";
import { LocaleSync } from "@/lib/i18n/locale-sync";
import { AuthProvider } from "./auth/auth-provider";
import { FullScreenLoader } from "./auth/guards";
import { router } from "./router";

/** Ex `app/layout.tsx`: the providers every route lives under. */
export function App() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <TooltipProvider>
        <SWRConfig value={{ fetcher: swrFetcher }}>
          <AuthProvider>
            <LocaleSync />
            {/* Translation namespaces load on demand: this is the boundary
                the very first catalogue suspends on. */}
            <Suspense fallback={<FullScreenLoader />}>
              <RouterProvider router={router} />
            </Suspense>
          </AuthProvider>
        </SWRConfig>
      </TooltipProvider>
      <Toaster richColors closeButton={true} />
    </ThemeProvider>
  );
}
